<template>
  <div id="footer">
    <SearchWidget
      @search="searchTerm => $emit('search', searchTerm)"
    />
    <div id="disclaimerText">
      *This map is meant to highlight some of the instances of retaliation
      against activists. It does NOT include all instances of retaliation,
      nor is it meant to be a representative sample of the geographic
      distribution of enforcement actions. Map tiles by <a href="http://stamen.com">Stamen Design</a>,
      under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>.
      Data by <a href="http://openstreetmap.org">OpenStreetMap</a>,
      under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.
    </div>
    <div class="spacer"></div>
    <div id="lastUpdatedText">Last updated 12/7/2020</div>
  </div>
</template>

<style scoped>
#footer {
  position: absolute;
  bottom: 0;
  height: 70px;
  width: 100%;
  display: flex;
  align-items: center;
  border-top: 2px solid black;
  background-color: white;
}
#disclaimerText {
  font-weight: bold;
  font-size: 10px;
  margin-left: 15px;
  text-align: left;
  width: 60%;
}
#lastUpdatedText {
  font-weight: bold;
  font-size: 10px;
  margin-right: 15px;
}
@media screen and (max-width: 1000px) {
  #footer {
    display: none;
  }
}
a, a:visited { color: black; }
</style>

<script>
import SearchWidget from './SearchWidget.vue';

export default {
  name: 'Footer',
  components: {
    SearchWidget,
  },
};
</script>
